import { useSelector, useDispatch } from "react-redux";
import { useState } from "react";
import {
  Container,
  Grid,
  Box,
  Paper
} from "@mui/material";
import Button from "@/components/ph/Button";
import Spinner from '@/components/ph/Spinner/Spinner';

import { putInsurance, issuePolicy, sendPolicyMessage } from '../insuranceSlice';

import InsuranceModal from './InsuranceModal';

import { 
  trackEventStep4Palacio, 
  trackEventStep4Other,
  trackEventConfirmPalacioContinue,
  trackEventConfirmPalacioExit,
  trackEventConfirmOtherCall,
  trackEventConfirmOtherClose
} from "../../../utils/analytics";

const InsurenceButtons = () => {
  const dispatch = useDispatch();
  const { validValues, idPoliza } = useSelector((state) => state.insurance);
  const allValid = Object.values(validValues).every((v) => v === true);

  const [contractType, setContractType] = useState('');
  const [buttonsDisabled, setButtonsDisabled] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: '',
    message: '',
    buttonLabel: ''
  });

  const handleContract = async (type) => {
    try {
      setButtonsDisabled(true);
      setIsLoading(true);
     
      setContractType(type);

      const result = await dispatch(putInsurance()).unwrap();
      if (!result) return;

      const issueResponse = await dispatch(issuePolicy()).unwrap();
      if (!issueResponse?.success) {
        throw new Error("No se pudo emitir la póliza");
      }

      if (type === "palacio") {
        // 2. AWAIT y PROTECCIÓN EN EL EVENTO DE PALACIO
        await trackEventStep4Palacio().catch(e => console.warn(e));
        
        setModalConfig({
          title: "VAS A PAGAR CON TARJETA PALACIO",
          message:
            "Serás redirigido a la pasarela de pagos. Para seguir debes iniciar sesión. Recibirás un correo con tu póliza, recuerda que esta no estará activa hasta que hayas completado el pago.",
          buttonLabel: "CONTINUAR Y PAGAR",
        });
      } else {
        // 3. AWAIT y PROTECCIÓN EN EL EVENTO DE OTRO MÉTODO
        await trackEventStep4Other().catch(e => console.warn(e));
        
        setModalConfig({
          title: "VAS A PAGAR CON OTRO MÉTODO",
          message:
            "Has recibido tu póliza. Para continuar tu pago comunícate a la Línea Seguros Palacio 5552291999 opción 5 seguido de la opción 2, o acude a tu Palacio favorito. Un agente te contactará pronto.",
          buttonLabel: "LLAMAR",
        });
      }
     
      setOpenModal(true);
     
    } catch (error) {
      setButtonsDisabled(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseModal = async () => {
    try {
      if (contractType === "palacio") {
        await trackEventConfirmPalacioExit();
      } else {
        await trackEventConfirmOtherClose();
      }
    } catch (e) {
      console.warn("Error enviando analítica de cierre:", e);
    } finally {
      setOpenModal(false);
      window.location.reload();
    }
  };
 
  const handleModalButtonClick = async () => {
    try {
      if (contractType === "palacio") {
        
        await trackEventConfirmPalacioContinue();
        
        if (idPoliza) {
          await dispatch(sendPolicyMessage({ idPoliza }));
        }

      } else if (contractType === "other") {
        
        trackEventConfirmOtherCall().catch(e => console.warn(e));
        const phoneNumber = "5552291999";
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
       
        if (isMobile) {
          window.location.href = `tel:${phoneNumber}`;
        } else {
          window.location.href = `skype:${phoneNumber}?call`;
        }
      }
    } catch (error) {
      console.warn("Error en botón principal del modal:", error);
    }
  };


  if (isLoading) {
    return (
        <Spinner variant="yellow" size={60} />
    );
  }

  return (
    <>
    <Container maxWidth="md" disableGutters={{ xs: true, md: false }}>
      <Paper elevation={0} sx={{ p: { md: 2 }, mb: { xs: 2, md: 2 } }}>
        <Grid container size={{ xs: 12, md: 12 }} spacing={2} justifyContent="center" alignItems="center">
          
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ width: '100%', maxWidth: { xs: 'none', md: 450}, mt: 2 }}>
              <Button
                label="CONTRATAR Y PAGAR CON TARJETA&nbsp;PALACIO"
                onClick={() => handleContract("palacio")}
                variant="black"
                disabled={!allValid || buttonsDisabled}
              />
            </Box>
          </Grid>
         
          <Grid size={{ xs: 12, md: 6 }}>
            <Box sx={{ width: '100%', maxWidth: { xs: 'none', md: 450}, mt: 2 }}>
              <Button
                label="CONTRATAR CON OTRO MEDIO DE PAGO"
                onClick={() => handleContract("other")}
                variant="white"
                disabled={!allValid  || buttonsDisabled}
              />
            </Box>
          </Grid>

        </Grid>
      </Paper>
    </Container>

    <InsuranceModal
      open={openModal}
      onClose={handleCloseModal}
      title={modalConfig.title}
      message={modalConfig.message}
      buttonLabel={modalConfig.buttonLabel}
      onButtonClick={handleModalButtonClick}
    />
    </>
  );
};

export default InsurenceButtons;
